import React, {
    useState,
    useEffect,
    useRef
} from "react";

import {
    Paper,
    Box,
    Tooltip,
    IconButton
} from '@mui/material';

import { LoadingButton } from '@mui/lab';
import SectionTitle from "../../common/SectionTitle";
import DownloadRoundedIcon from '@mui/icons-material/DownloadRounded';
import CloudUploadRoundedIcon from '@mui/icons-material/CloudUploadRounded';
import CurrentClientContext from "../../../providers/CurrentClientProvider";
import TagService from "../../../services/TagService";
import TipsContext from '../../../providers/GlobalTip';
import ClientService from "../../../services/ClientService";
import PosService from "../../../services/PosService";

function ClientPosMappingUpload(props) {
    const [uploading, setUploading] = useState(false)
    const currentClientContext = CurrentClientContext.useClient();
    const fileInputRef = useRef();
    const tip_context = TipsContext.useMessage();
    const {success} = props

    const chooseFile = () => {
        fileInputRef.current.click()
    }

    async function uploadClientPos(e) {
        try {
            setUploading(true)
            const result = await ClientService.uploadClientPos(currentClientContext.client?.Id, e.target.files[0])
            tip_context.showSuccess('Upload successfully')
            success()
        } catch(e) {
            tip_context.show(e.response.data.message)
        }
        setUploading(false)
    }

    function downloadPosExample() {
        PosService.downloadPos(currentClientContext.client?.Id)
    }

    return <Paper elevation={2} sx={{height: '200px'}}>
        <SectionTitle
            type="primary"
            label="Import Mapping"
            rightComponent={
                <Tooltip title="Download Template">
                    <IconButton component="button" onClick={downloadPosExample} target="_blank" sx={{color: 'white'}}>
                        <DownloadRoundedIcon />
                    </IconButton>
                </Tooltip>
            }
        />
        <Box sx={{p:1.5}}>
            <Box>Client ID: {currentClientContext.client?.Id}</Box>
            <Box
                component="input"
                type='file'
                name="data"
                sx={{display:'none'}}
                ref={fileInputRef}
                accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel, .csv"
                onChange={uploadClientPos}
                onClick={(event)=> {
                    event.target.value = null
                }}
            ></Box>
            <LoadingButton
                loading={uploading}
                fullWidth
                size="large"
                startIcon={<CloudUploadRoundedIcon />}
                onClick={chooseFile}
                sx={css.uploadButton}
            >Upload</LoadingButton>
        </Box>
    </Paper>
}

const css = {
    uploadButton: {
        py: 2,
        border: '1px dashed transparent',
        borderColor: 'primary.main',
        borderRadius: 2,
        mt: 2,
    },
}

export default ClientPosMappingUpload